/** Contenedor horizontal compartido — alineado con hubs Serenity (max-w-7xl). */
export const BEGINNER_PATH_PAGE_CLASS =
  "mx-auto w-full max-w-7xl px-6 py-10 pb-24 md:px-10 lg:px-12";

export const BEGINNER_PATH_SECTION_CLASS = "w-full";

/** Grid de fases del índice del camino. */
export const BEGINNER_PATH_PHASES_GRID_CLASS =
  "grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-5 xl:gap-6";

/** Gym en modo camino: hero + ejercicios lado a lado en desktop. */
export const BEGINNER_PATH_GYM_LAYOUT_CLASS =
  "grid grid-cols-1 gap-6 xl:grid-cols-[minmax(300px,380px)_1fr] xl:items-start";

export const BEGINNER_PATH_EXERCISE_GRID_CLASS =
  "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3";

/** Estudio de ejercicio: mástil usa todo el ancho útil (sin scale CSS que recorta). */
export const BEGINNER_PATH_STUDIO_NECK_CLASS =
  "relative w-full h-full max-w-[min(100%,min(1360px,calc(100vw-2rem)))] mx-auto";
